import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Ticket, ArrowRight } from "lucide-react";
import { track, api } from "../lib/api";
import { NewsletterForm } from "../components/Footer";
import { ProductCard } from "../components/ProductCard";
import { toast } from "sonner";

export default function ShowLanding() {
  const [params] = useSearchParams();
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    const source = params.get("utm_source") || params.get("source") || "gun_show_qr";
    sessionStorage.setItem("shodan_source", source);
    sessionStorage.setItem("shodan_coupon", "GUNSHOW10");
    track("show_page_visit", source, { utm_campaign: params.get("utm_campaign") || null });
    api.get("/products?best_seller=true&limit=4").then(({ data }) => setFeatured(data.products)).catch(() => {});
  }, [params]);

  return (
    <div className="min-h-screen bg-[#121212] text-white">
      <div className="max-w-md mx-auto px-5 py-14 text-center">
        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#8FA84E] font-mono">Shodan Security · Event Special</p>
        <h1 className="font-heading font-black text-4xl uppercase tracking-tighter mt-3 leading-tight">Welcome to Shodan Security</h1>
        <p className="text-white/70 mt-4 text-sm">Thanks for visiting our booth. Get <span className="text-white font-bold">10% off</span> your first online order.</p>
        <div data-testid="show-coupon-box" className="mt-8 border-2 border-dashed border-[#8FA84E] bg-white/5 p-6">
          <div className="flex items-center justify-center gap-2 text-[#8FA84E]"><Ticket size={18} /><span className="text-xs font-bold uppercase tracking-widest">Your Coupon</span></div>
          <p data-testid="show-coupon-code" className="font-mono font-black text-3xl tracking-[0.2em] mt-2">GUNSHOW10</p>
          <button data-testid="copy-coupon-btn" onClick={() => { navigator.clipboard?.writeText("GUNSHOW10"); toast.success("Coupon copied — it'll auto-apply at checkout"); }}
            className="mt-3 text-[11px] font-bold uppercase tracking-widest text-white/60 underline hover:text-white">Tap to copy</button>
        </div>
        <Link data-testid="show-shop-btn" to="/shop" className="mt-8 flex items-center justify-center gap-2 bg-[#4A5D23] text-white py-5 text-sm font-bold uppercase tracking-widest hover:bg-[#3D4D1D] transition-colors duration-150 w-full">
          Shop Shodan Security <ArrowRight size={16} />
        </Link>
        <p className="text-[11px] text-white/40 mt-3">Coupon auto-applies at checkout. One use per customer.</p>
        <div className="mt-12 text-left">
          <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-3">Get the Free Preparedness Checklist</h2>
          <NewsletterForm source="gun_show" dark />
        </div>
        {featured.length > 0 && (
          <div className="mt-12 text-left">
            <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">Booth Favorites</h2>
            <div className="grid grid-cols-2 gap-3">{featured.map((p) => <ProductCard key={p.slug} product={p} />)}</div>
          </div>
        )}
      </div>
    </div>
  );
}
